/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const getTekeTagTable = params => {
  return axios.post(`${base}/teke/query_tag`, params)
}

export const createTekeTag = params => {
  return axios.post(`${base}/teke/create_tag`, params)
}

export const editTekeTag = params => {
  return axios.post(`${base}/teke/edit_tag_` + params.id, params)
}

export const deleteTekeTag = id => {
  return axios.post(`${base}/teke/delete_tag_` + id)
}

export const getTekeInfiniteTagTable = params => {
  return axios.post(`${base}/teke/query_infinite_tag_` + params.pid, params)
}

export const createTekeInfiniteTag = params => {
  return axios.post(`${base}/teke/create_infinite_tag_` + params.pid, params)
}

export const editTekeInfiniteTag = params => {
  return axios.post(`${base}/teke/edit_infinite_tag_` + params.id, params)
}

export const getTekeTag = id => {
  return axios.get(`${base}/teke/tag_` + id)
}

export const batchAddTeke = params => {
  return axios.post(`${base}/teke/batch_add_tag`, params)
}

export const batchDeleteTeke = params => {
  return axios.post(`${base}/teke/batch_delete_tag`, params)
}

export const getTekeInfiniteTagUpload = params => {
  return axios.post(`${base}/excel/query_upload`, params)
}

export const downTekeSourceFile = id => {
  window.location.href = `${base}/excel/down_sourc_file_` + id
}

export const downTekeErrorFile = id => {
  window.location.href = `${base}/excel/down_error_file_` + id
}

export const batchUploadTekeTagEdit = params => {
  return axios.post(`${base}/teke/batch_edit_tag_upload`, params)
}

export const batchUploadTekeTagLib = params => {
  return axios.post(`${base}/teke/batch_tag_lib_upload`, params)
}

export const downloadAllTagFile = params => {
  return axios.post(`${base}/teke/download_all_tag_file`, params)
}
export const getBatchjobOnGoingNumber = params => {
  return axios.get(`${base}/excel/query_ongoing_number`)
}



// WEBPACK FOOTER //
// ./src/views/teke-tag/tekeTag.api.js